<template>
  <div class="flex w-full flex-col gap-2">
    <slot />
  </div>
</template>
